import { KdsTicket } from '../types/ticket';

export const filterByChannels = (tickets: KdsTicket[], activeChannels: number[]): KdsTicket[] =>
    tickets.filter(({ channelId }) => activeChannels.includes(channelId));
